module.exports = __webpack_public_path__ + "img/bb.a8275f8c.png";